import "@/style/index.css";
import "reactflow/dist/style.css";

import App from "@/App";
import { AuthContextType, AuthUserContext } from "@/hooks/useAuthUser";
import { initI18n } from "@/i18n";
import { PlugConfigMeta } from "@/types/plugConfig";
import mansoqConfig from "@mansoqConfig";
import React, { Context } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { initZod } from "./lib/zod";

// Extend Window interface to include MANSOQ_API_URL
declare global {
  interface Window {
    MANSOQ_API_URL: string;
    __CORE_ENV__: typeof mansoqConfig;
    __CARE_PLUGIN_RUNTIME__: { meta: PlugConfigMeta };
    AuthUserContext: Context<AuthContextType | null>;
  }
}

// Expose Environment variable to window object for use in plugins
window.MANSOQ_API_URL = mansoqConfig.apiUrl;
window.AuthUserContext = AuthUserContext;
window.__CORE_ENV__ = mansoqConfig;

if ("serviceWorker" in navigator) {
  registerSW({ immediate: false });
}

function initApp() {
  const container = document.getElementById("root");

  if (!container) {
    throw new Error("Root container not found");
  }

  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// Initialize i18n with namespaces from API before rendering the app
initI18n()
  .catch((error) => {
    console.error("Failed to initialize i18n:", error);
  })
  .finally(() => {
    initZod();
    initApp();
  });
